import React from 'react';

import { Form } from '@unform/web';
import { useFormik, FormikProvider } from 'formik';
import moment from 'moment';

import Button from '~/components/Button';
import DateRange, { DateRangeValues } from '~/components/Formik/DateRange';
import { IReport } from '~/store/modules/reports/types';

import { ButtonContainer } from '../styles';

export interface ReportFormData {
  dateRange: DateRangeValues;
}

interface ReportFormProps {
  ref: any;
  selectedReport: IReport | null;
  onSubmit: (data: ReportFormData) => void;
}

const ReportForm = ({ ref, selectedReport, onSubmit }: ReportFormProps) => {
  const initialValues: ReportFormData = {
    dateRange: [
      {
        startDate: moment(new Date()).startOf('day').toDate(),
        endDate: moment(new Date()).endOf('day').toDate(),
        key: 'selection',
      },
    ],
  };

  const formik = useFormik({ initialValues, onSubmit });

  return (
    <FormikProvider value={formik}>
      {selectedReport?.reportFilters.map(
        (reportFilter) =>
          reportFilter.type === 'DATE_RANGE' && (
            <>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '310px',
                }}
              >
                <Form
                  ref={ref}
                  onSubmit={() => {}}
                  style={{
                    margin: '16px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    gap: '16px',
                  }}
                >
                  <DateRange name="dateRange" />
                </Form>
              </div>
            </>
          ),
      )}
      <ButtonContainer>
        <div>
          <button
            type="button"
            onClick={() => {
              formik.setFieldValue('dateRange', [
                { startDate: null, endDate: null, key: 'selection' },
              ]);
            }}
            style={{
              border: 'none',
              background: 'transparent',
              color: '#4D4D4D',
            }}
          >
            Limpar
          </button>
        </div>
        <div>
          <Button
            type="button"
            onClick={() => formik.handleSubmit()}
            disabled={formik.values.dateRange[0].startDate === null}
          >
            Confirmar
          </Button>
        </div>
      </ButtonContainer>
    </FormikProvider>
  );
};

export default ReportForm;
